"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var React = require("react");
var types_1 = require("./types");
var Spinner_st_css_1 = require("./Spinner.st.css");
var Spinner = /** @class */ (function (_super) {
    __extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        var _a = this.props, className = _a.className, type = _a.type, diameter = _a.diameter, isCentered = _a.isCentered, isStatic = _a.isStatic;
        return (React.createElement("svg", { viewBox: "0 0 50 50", className: Spinner_st_css_1.st(Spinner_st_css_1.classes.root, { centered: !!isCentered, static: !!isStatic }, className), style: {
                width: diameter + "px",
                height: diameter + "px",
                top: isCentered ? "calc(50% - " + diameter / 2 + "px)" : 'auto',
                left: isCentered ? "calc(50% - " + diameter / 2 + "px)" : 'auto',
            }, "data-hook": this.props['data-hook'] },
            React.createElement("circle", { cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: type === types_1.SpinnerTypes.regular ? 4 : 1, className: Spinner_st_css_1.classes.circle })));
    };
    Spinner.displayName = 'Spinner';
    Spinner.defaultProps = {
        type: types_1.SpinnerTypes.regular,
        diameter: 50,
        isCentered: false,
        isStatic: false,
    };
    return Spinner;
}(React.Component));
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map